import { useAwardsData } from "@/hooks/data/useAwardsData";
import Image from "next/image";
import { Container } from "@/components/ui/container";
import S from "./index.module.scss";

const AwardSection = () => {
  const { awards, isLoading } = useAwardsData();

  if (!awards || !awards.awards?.length || isLoading) return null;

  return (
    <Container className={S.wrapper}>
      <h2 className={S.title}>{awards.title}</h2>
      <div className={S.awardContainer}>
        {awards.awards.map(item => (
          <div className={S.awardItem} key={item.title}>
            <Image src={item.preview_image} width={56} height={56} alt={item.title} />
            <p className={S.awardCount}>{item.count}</p>
            <p>{item.title}</p>
          </div>
        ))}
      </div>
    </Container>
  );
};

export default AwardSection;
